import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  CreateCustomFieldInput,
  CreateCustomFieldMutation,
} from '@/gql/graphql';

const CREATE_CUSTOM_FIELD_MUTATION = graphql(`
  mutation CreateCustomField($input: CreateCustomFieldInput!) {
    createCustomField(input: $input) {
      role
      id
      customFields {
        archivedAt
        id
        identifier
        isRequired
        label
        type
        options
        schema
      }
    }
  }
`);

const useCreateCustomField = (
  options?: UseMutationOptions<
    CreateCustomFieldMutation,
    unknown,
    CreateCustomFieldInput
  >
) => {
  return useMutation({
    mutationFn: (variables) => {
      return gqlClient.request(CREATE_CUSTOM_FIELD_MUTATION, {
        input: variables,
      });
    },
    ...options,
  });
};

export default useCreateCustomField;
